import View from "../../../Nav/Js/views/PubliStickyNav";
import components from "./components.js";
components.define("js-PubliSticky", View);